// Baselayer Results Explorer — Secretary-of-State filings tab. Table of
// registrations: status/standing, issue date, registration type
// (domestic/foreign), name, registered agent.

import {
  Table,
  THead,
  TBody,
  TR,
  TH,
  TD,
  EmptyState,
} from "@/design-system/components/ui";
import { formatLooseDate } from "../tabHelpers";
import {
  asArray,
  asObject,
  asString,
  pick,
  type ParsedKyb,
} from "../parse";

export function SosFilingsTab({ kyb }: { kyb: ParsedKyb }) {
  const b = kyb.business;
  const raw = asArray(
    pick(b, "registrations", "sos_filings") ?? pick(kyb.raw, "registrations"),
  );

  const filings = raw.map((r) => {
    const o = asObject(r);
    return {
      status:
        asString(pick(o, "status", "standing", "filing_status")) ?? "—",
      issueDate: asString(pick(o, "issue_date", "registration_date", "date")),
      registrationType:
        asString(pick(o, "registration_type", "type", "domestic_foreign")) ??
        "—",
      name: asString(pick(o, "name", "entity_name")) ?? "—",
      registeredAgent:
        asString(pick(o, "registered_agent_name", "registered_agent")) ?? "—",
    };
  });

  if (filings.length === 0) {
    return (
      <EmptyState
        title="No Secretary of State filings"
        description="No SoS registrations were returned for this subject."
      />
    );
  }

  return (
    <Table>
      <THead>
        <TR>
          <TH>Name</TH>
          <TH>Status / standing</TH>
          <TH>Type</TH>
          <TH>Issue date</TH>
          <TH>Registered agent</TH>
        </TR>
      </THead>
      <TBody>
        {filings.map((f, i) => (
          <TR key={`${f.name}-${i}`}>
            <TD>{f.name}</TD>
            <TD>{f.status}</TD>
            <TD className="capitalize">{f.registrationType}</TD>
            <TD>{formatLooseDate(f.issueDate)}</TD>
            <TD>{f.registeredAgent}</TD>
          </TR>
        ))}
      </TBody>
    </Table>
  );
}
